var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useCookieConsent } from '../../contexts';
import { ButtonEx } from '../ButtonEx';
import { FlexRow } from '../FlexBox';
const CookieConsentBody = (_a) => {
    var { acceptOnScroll, acceptOnTimer, onAccept } = _a, props = __rest(_a, ["acceptOnScroll", "acceptOnTimer", "onAccept"]);
    const { accepted, setAccepted, storageName } = useCookieConsent();
    const onScroll = () => {
        //hide it one the user has scrolled at least one page
        if (window.scrollY > window.innerHeight && !accepted) {
            onAcceptClick();
        }
    };
    if (acceptOnTimer && !accepted) {
        setTimeout(() => {
            onAcceptClick();
        }, acceptOnTimer);
    }
    useEffect(() => {
        if (acceptOnScroll) {
            window.addEventListener('scroll', onScroll);
            return () => {
                window.removeEventListener('scroll', onScroll);
            };
        }
    });
    const onAcceptClick = () => {
        if (setAccepted) {
            console.log('onAcceptClick1');
            setAccepted === null || setAccepted === void 0 ? void 0 : setAccepted(true);
        }
        else {
            console.log(`onAcceptClick2: ${storageName}`);
            localStorage.setItem(storageName !== null && storageName !== void 0 ? storageName : 'CookiesAccepted', 'true');
        }
        onAccept === null || onAccept === void 0 ? void 0 : onAccept(true);
    };
    if (!storageName) {
        return (_jsx(FlexRow, Object.assign({ justifyContent: "center", paddingY: 2 }, props, { children: _jsx(Typography, Object.assign({ color: "error", variant: "body1" }, { children: "Missing CookieConsentContext" }), void 0) }), void 0));
    }
    return accepted ? null : (_jsxs(FlexRow, Object.assign({ justifyContent: "space-between" }, props, { children: [_jsxs(Typography, Object.assign({ variant: "body2", margin: 2 }, { children: ['This site uses ', _jsx(Link, Object.assign({ href: "https://cookiesandyou.com/", rel: "noopener noreferrer", target: "_blank" }, { children: "cookies" }), void 0), ' and ', _jsx(Link, Object.assign({ href: "https://policies.google.com/technologies/partner-sites", rel: "noopener noreferrer", target: "_blank" }, { children: "Google\u00A0tools" }), void 0), ' to analyze traffic and for ads measurement purposes.'] }), void 0), _jsx(ButtonEx, Object.assign({ variant: "contained", color: "secondary", onClick: onAcceptClick, margin: 2 }, { children: "Accept" }), void 0)] }), void 0));
};
export default CookieConsentBody;
//# sourceMappingURL=CookieConsentBody.js.map